import React, { Component } from 'react';
import {
  FormGroup, Label,
  Input,
  Row, Col,
  Card, CardBody
} from 'reactstrap';
import AddEditSubsidiariesService from '../../services/AddEditSubsidiariesService';
import Validation from '../../services/Validation';
import TextareaAutosize from 'react-autosize-textarea';
import NewFleetService from '../../services/NewFleetService';
import CustomSpinner from '../CustomSpinner/CustomSpinner';


class NewFleetBusinessDetail extends Component {
  constructor(props) {
    super(props);
    const userDetail = props.userDetail;
    this.state = {
      userDetail: userDetail,
      controls: {
        same_as_mobile: {
          value: false,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        is_prospective: {
          value: false,
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        company_name: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        company_type: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        owner_name: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        designation: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        mobile_number: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidPhone: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        phone_number: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidPhone: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        whatsapp_number: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          invalidLength: null,
          showErrorMsg: false
        },
        email: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          invalidLength: null,
          showErrorMsg: false
        },
        website: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          invalidLength: null,
          showErrorMsg: false
        },
        address: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          invalidLength: null,
          showErrorMsg: false
        },
        state: {
          value: null,
          valid: true,
          required: false,
          touched: false,
          invalidLength: null,
          showErrorMsg: false
        },
        city: {
          value: null,
          valid: true,
          required: false,
          touched: false,
          invalidLength: null,
          showErrorMsg: false
        },
        pin_code: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        pan_number: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        gst_number: {
          value: '',
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        fleet_manager: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        depot: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        region: {
          value: null,
          valid: true,
          touched: false,
          required: false,
          showErrorMsg: false
        },
        sales_officer: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        sales_manager: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        area_sales_manager: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        enrollment_type: {
          value: 'direct',
          valid: null,
          touched: false,
          nullValue: null,
          invalidEmail: null,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        },
        sap_id: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
          isExitsSapId: false,
          required: true,
          showErrorMsg: false,
          autoFocus: false
        }
      },
      isValidForm: false,
      isLoading: false,
      stateData: [],
      cityData: [],
      fleetByIdData: {},
      is_display_prospective: true
    }
  }

  checkProspectiveStatus = (row) => {
    let { is_display_prospective, controls } = this.state;
    if (row.is_draft) {
      is_display_prospective = true;
    } else if (row.prospective_status === null) {
      is_display_prospective = true;
    } else if (row.prospective_status === 'modification') {
      is_display_prospective = true;
    } else if (row.prospective_status === 'approve') {
      is_display_prospective = false;
    } else if (row.prospective_status === 'reject') {
      is_display_prospective = true;
    }
    this.setState({
      is_display_prospective
    }, () => {
      if (this.props.changeFleetRegType) {
        this.props.changeFleetRegType(controls.is_prospective.value);
      }

    });
  }

  setFleetDetail = () => {
    let { fleetByIdData, controls } = this.state;
    fleetByIdData = this.props.fleetByIdData
    if (fleetByIdData && Object.keys(fleetByIdData).length > 0) {
      controls.company_name.value = fleetByIdData.company_name;
      controls.company_type.value = fleetByIdData.company_type;
      controls.owner_name.value = fleetByIdData.owner_name;
      controls.designation.value = fleetByIdData.designation;
      controls.mobile_number.value = fleetByIdData.mobile_number;
      controls.phone_number.value = fleetByIdData.phone_number;
      controls.whatsapp_number.value = fleetByIdData.whatsapp_number;
      controls.email.value = fleetByIdData.email;
      controls.website.value = fleetByIdData.website;
      controls.address.value = fleetByIdData.address;
      controls.state.value = fleetByIdData.state;
      controls.city.value = fleetByIdData.city;
      controls.pin_code.value = fleetByIdData.pin_code;
      controls.pan_number.value = fleetByIdData.pan_number ? fleetByIdData.pan_number.toString().toUpperCase() : '';
      controls.gst_number.value = fleetByIdData.gst_number ? fleetByIdData.gst_number.toString().toUpperCase() : '';
      controls.fleet_manager.value = fleetByIdData.fleet_manager;
      controls.depot.value = fleetByIdData.depot;
      controls.region.value = fleetByIdData.region_name;
      controls.sales_officer.value = fleetByIdData.sales_officer;
      controls.sales_manager.value = fleetByIdData.sales_manager;
      controls.area_sales_manager.value = fleetByIdData.area_sales_manager;
      if (fleetByIdData.enrollment_type) {
        controls.enrollment_type.value = fleetByIdData.enrollment_type;
      } else {
        controls.enrollment_type.value = "direct";
      }
      controls.is_prospective.value = fleetByIdData.is_prospective;
      controls.sap_id.value = fleetByIdData.sap_id;
      if (fleetByIdData.is_prospective && fleetByIdData.prospective_status === 'approve') {
        controls.is_prospective.value = false;
      }
      this.setState({
        controls,
        fleetByIdData
      }, () => {
        if (fleetByIdData.is_prospective && fleetByIdData.prospective_status === 'approve') {
          if (this.props.changeFleetRegType) {
            this.props.changeFleetRegType(controls.is_prospective.value);
          }

        }
      });
      this.getState();
      this.getCity();
      this.checkProspectiveStatus(fleetByIdData);
    }
  }
  componentDidMount() {
    this.getState();
    let data = NewFleetService.getFleetData();
    let { controls, userDetail } = this.state;
    if (data && Object.keys(data).length > 0 && data.newFleetBusinessDetail) {
      controls = data.newFleetBusinessDetail;
      this.setState((prevState) => {
        return { ...prevState, controls };
      });
    }
    controls.region.value = userDetail && userDetail.region_name ? userDetail.region_name : '';
    this.setState((prevState) => {
      return { ...prevState, controls };
    });
  }

  saveDraftValidation = (isSubmit = false) => {
    let { controls } = this.state;
    let isValidForm = false;
    let { company_name, mobile_number, email } = controls;
    if (company_name.touched === true || isSubmit) {
      company_name = Validation.notNullValidator(company_name);
      company_name.valid = !company_name.nullValue;
      if (company_name.valid === false) {
        company_name.showErrorMsg = true;
      } else {
        company_name.showErrorMsg = false;
      }
    }


    if (email.touched === true || isSubmit) {
      email = Validation.notNullValidator(email);
      email = Validation.emailValidator(email);
      email.valid = !(email.nullValue || email.invalidEmail);
      if (email.valid === false) {
        email.showErrorMsg = true;
      } else {
        email.showErrorMsg = false;
      }
    }

    if (mobile_number.touched === true || isSubmit) {
      mobile_number = Validation.notNullValidator(mobile_number);
      mobile_number = Validation.validatePhoneNumber(mobile_number);
      mobile_number = Validation.validateLength(mobile_number, 10);
      mobile_number.valid = !(mobile_number.invalidPhone || mobile_number.nullValue || mobile_number.invalidLength);
      if (mobile_number.valid === false) {
        mobile_number.showErrorMsg = true;
      } else {
        mobile_number.showErrorMsg = false;
      }
    }

    if (
      company_name.valid === true &&
      email.valid === true &&
      mobile_number.valid === true
    ) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }

    this.setState({ controls });
    return isValidForm;

  }

  handleValidation = (isSubmit = false) => {
    let { controls, isValidForm } = this.state;
    let { company_name, company_type, owner_name, designation, state, city, mobile_number, phone_number, whatsapp_number
      , address, email, pin_code, gst_number, pan_number, fleet_manager, depot,
      // region, sales_officer, sales_manager, 
      area_sales_manager,
      enrollment_type, is_prospective, sap_id
    } = controls;

    if (email.touched === true || isSubmit) {
      email = Validation.notNullValidator(email);
      email = Validation.emailValidator(email);
      email.valid = !(email.nullValue || email.invalidEmail);
      if (email.valid === false) {
        email.showErrorMsg = true;
      } else {
        email.showErrorMsg = false;
      }
    }

    if (company_name.touched === true || isSubmit) {
      company_name = Validation.notNullValidator(company_name);
      company_name.valid = !company_name.nullValue;
      if (company_name.valid === false) {
        company_name.showErrorMsg = true;
      } else {
        company_name.showErrorMsg = false;
      }
    }

    if (company_type.touched === true || isSubmit) {
      company_type = Validation.notNullValidator(company_type);
      company_type.valid = !company_type.nullValue;
      if (company_type.valid === false) {
        company_type.showErrorMsg = true;
      } else {
        company_type.showErrorMsg = false;
      }
    }

    if (owner_name.touched === true || isSubmit) {
      owner_name = Validation.notNullValidator(owner_name);
      owner_name.valid = !owner_name.nullValue;
      if (owner_name.valid === false) {
        owner_name.showErrorMsg = true;
      } else {
        owner_name.showErrorMsg = false;
      }
    }

    if (designation.touched === true || isSubmit) {
      designation = Validation.notNullValidator(designation);
      designation.valid = !designation.nullValue;
      if (designation.valid === false) {
        designation.showErrorMsg = true;
      } else {
        designation.showErrorMsg = false;
      }
    }

    if (state.touched === true || isSubmit) {
      state = Validation.notNullValidator(state);
      state.valid = !state.nullValue;
      if (state.valid === false) {
        state.showErrorMsg = true;
      } else {
        state.showErrorMsg = false;
      }
    }


    if (city.touched === true || isSubmit) {
      city = Validation.notNullValidator(city);
      city.valid = !city.nullValue;
      if (city.valid === false) {
        city.showErrorMsg = true;
      } else {
        city.showErrorMsg = false;
      }
    }

    if (address.touched === true || isSubmit) {
      address = Validation.notNullValidator(address);
      address.valid = !address.nullValue;
      if (address.valid === false) {
        address.showErrorMsg = true;
      } else {
        address.showErrorMsg = false;
      }
    }

    // if (fleet_manager.touched === true || isSubmit) {
    //   fleet_manager = Validation.notNullValidator(fleet_manager);
    //   fleet_manager.valid = !fleet_manager.nullValue;
    //   if (fleet_manager.valid === false) {
    //     fleet_manager.showErrorMsg = true;
    //   } else {
    //     fleet_manager.showErrorMsg = false;
    //   }
    // }

    if (depot.touched === true || isSubmit) {
      depot = Validation.notNullValidator(depot);
      depot.valid = !depot.nullValue;
      if (depot.valid === false) {
        depot.showErrorMsg = true;
      } else {
        depot.showErrorMsg = false;
      }
    }

    // if (region.touched === true || isSubmit) {
    //   region = Validation.notNullValidator(region);
    //   region.valid = !region.nullValue;
    //   if (company_type.valid === false) {
    //     region.showErrorMsg = true;
    //   } else {
    //     region.showErrorMsg = false;
    //   }
    // }

    // if (sales_officer.touched === true || isSubmit) {
    //   sales_officer = Validation.notNullValidator(sales_officer);
    //   sales_officer.valid = !sales_officer.nullValue;
    //   if (sales_officer.valid === false) {
    //     sales_officer.showErrorMsg = true;
    //   } else {
    //     sales_officer.showErrorMsg = false;
    //   }
    // }


    // if (sales_manager.touched === true || isSubmit) {
    //   sales_manager = Validation.notNullValidator(sales_manager);
    //   sales_manager.valid = !sales_manager.nullValue;
    //   if (sales_manager.valid === false) {
    //     sales_manager.showErrorMsg = true;
    //   } else {
    //     sales_manager.showErrorMsg = false;
    //   }
    // }

    if (area_sales_manager.touched === true || isSubmit) {
      area_sales_manager = Validation.notNullValidator(area_sales_manager);
      area_sales_manager.valid = !area_sales_manager.nullValue;
      if (area_sales_manager.valid === false) {
        area_sales_manager.showErrorMsg = true;
      } else {
        area_sales_manager.showErrorMsg = false;
      }
    }



    if (!is_prospective.value && (gst_number.touched === true || isSubmit)) {
      gst_number = Validation.notNullValidator(gst_number);
      if (!gst_number.nullValue) {
        gst_number.value = gst_number.value.toUpperCase();
      }
      gst_number = Validation.validateGST(gst_number);
      gst_number.valid = !(gst_number.invalidGST || gst_number.nullValue);
      if (gst_number.valid === false) {
        gst_number.showErrorMsg = true;
      } else {
        gst_number.showErrorMsg = false;
      }
    }

    if (!is_prospective.value && (pan_number.touched === true || isSubmit)) {
      pan_number = Validation.notNullValidator(pan_number);
      pan_number = Validation.validatePAN(pan_number);
      //pan_number = Validation.validateLength(pan_number, 10);
      pan_number.valid = !(pan_number.invalidPAN || pan_number.nullValue);
      if (pan_number.valid === false) {
        pan_number.showErrorMsg = true;
      } else {
        pan_number.showErrorMsg = false;
      }
    }

    if (pin_code.touched === true || isSubmit) {
      pin_code = Validation.notNullValidator(pin_code);
      pin_code = Validation.validateLength(pin_code, 6);
      pin_code.valid = !(pin_code.invalidLength || pin_code.nullValue);
      if (pin_code.valid === false) {
        pin_code.showErrorMsg = true;
      } else {
        pin_code.showErrorMsg = false;
      }
    }

    if (mobile_number.touched === true || isSubmit) {
      mobile_number = Validation.notNullValidator(mobile_number);
      mobile_number = Validation.validatePhoneNumber(mobile_number);
      mobile_number = Validation.validateLength(mobile_number, 10);
      mobile_number.valid = !(mobile_number.invalidPhone || mobile_number.nullValue || mobile_number.invalidLength);
      if (mobile_number.valid === false) {
        mobile_number.showErrorMsg = true;
      } else {
        mobile_number.showErrorMsg = false;
      }
    }

    if (whatsapp_number.touched === true || isSubmit) {
      whatsapp_number = Validation.notNullValidator(whatsapp_number);
      whatsapp_number = Validation.validatePhoneNumber(whatsapp_number);
      mobile_number = Validation.validateLength(whatsapp_number, 10);
      whatsapp_number.valid = !(whatsapp_number.invalidPhone || whatsapp_number.nullValue ||
        whatsapp_number.invalidLength);
      if (whatsapp_number.valid === false) {
        whatsapp_number.showErrorMsg = true;
      } else {
        whatsapp_number.showErrorMsg = false;
      }
    }

    if (phone_number.touched === true || isSubmit) {
      phone_number = Validation.notNullValidator(phone_number);
      phone_number = Validation.validatePhoneNumber(phone_number);
      // phone_number = Validation.validateLength(phone_number, 11);
      phone_number.valid = !(phone_number.invalidPhone || phone_number.nullValue ||
        phone_number.invalidLength);
      if (phone_number.valid === false) {
        phone_number.showErrorMsg = true;
      } else {
        phone_number.showErrorMsg = false;
      }
    }

    if (!is_prospective.value && (enrollment_type.touched === true || isSubmit)) {
      enrollment_type = Validation.notNullValidator(enrollment_type);
      enrollment_type.valid = !enrollment_type.nullValue;
      if (enrollment_type.valid === false) {
        enrollment_type.showErrorMsg = true;
      } else {
        enrollment_type.showErrorMsg = false;
      }
    }
    if (controls.enrollment_type.value === null) {
      controls.enrollment_type.value = '';
    }
    if (!is_prospective.value && (controls.enrollment_type.value.toLowerCase() === 'direct' || controls.enrollment_type.value.toLowerCase() === 'mobility')
      && (sap_id.touched === true || isSubmit)) {
      sap_id = Validation.notNullValidator(sap_id);
      if (!sap_id.nullValue) {
        sap_id = Validation.maxLengthValidator(sap_id, 8);
        sap_id = Validation.minLengthValidator(sap_id, 6);
      }
      sap_id.valid = !sap_id.nullValue && !sap_id.invalidLength && !sap_id.invalidMinLength;
      if (sap_id.valid === true) {
        sap_id.showErrorMsg = false;
      } else {
        sap_id.showErrorMsg = true;

      }
    } else {
      sap_id.showErrorMsg = false;
      sap_id.valid = true;
      sap_id.isExitsSapId = false;
    }

    if (is_prospective.value) {
      enrollment_type.valid = true;
      enrollment_type.showErrorMsg = false;
      gst_number.valid = true;
      gst_number.showErrorMsg = false;
      pan_number.valid = true;
      pan_number.showErrorMsg = false;
      sap_id.showErrorMsg = false;
      sap_id.valid = true;
    }

    if (
      email.valid === true &&
      company_name.valid === true &&
      company_type.valid === true &&
      owner_name.valid === true &&
      state.valid === true &&
      city.valid === true &&
      mobile_number.valid === true &&
      whatsapp_number.valid === true &&
      phone_number.valid === true &&
      address.valid === true &&
      pin_code.valid === true &&
      gst_number.valid === true &&
      pan_number.valid === true &&
      fleet_manager.valid === true &&
      depot.valid === true &&
      area_sales_manager.valid === true &&
      enrollment_type.valid === true &&
      sap_id.valid === true
    ) {
      isValidForm = true;
    } else {
      isValidForm = false;
    }

    this.setState({ controls, isValidForm });
    return isValidForm;
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;

    if (controlName === 'sap_id' || controlName === 'mobile_number') {
      if (!isNaN(controlValue)) {
        controls[controlName].value = controlValue;
      } else {
        return
      }
    } else if (controlName === 'same_as_mobile') {
      controls.same_as_mobile.value = !controls.same_as_mobile.value;
      if (!controls.mobile_number.showErrorMsg && controls.mobile_number.value && controls.same_as_mobile.value) {
        controls.whatsapp_number.value = controls.mobile_number.value;
        controls.whatsapp_number.touched = true;
        controls.same_as_mobile.value = true;
      } else {
        controls.whatsapp_number.value = '';
        controls.same_as_mobile.value = false;
      }
    } else if (controlName === 'gst_number' || controlName === 'pan_number') {
      controls[controlName].value = controlValue ? controlValue.toString().toUpperCase() : ''
    } else {
      controls[controlName].value = controlValue;
    }
    controls[controlName].touched = true;
    if (controlName === 'state') {
      this.getCity();
    }
    if (controlName === 'company_type') {
      if (e.target.value === 'proprietor') {
        controls.designation.value = 'owner';
      } else if (e.target.value === 'partnership') {
        controls.designation.value = 'partner';
      } else if (e.target.value === 'private limited') {
        controls.designation.value = 'director';
      } else if (e.target.value === 'limited') {
        controls.designation.value = 'director';
      }
      controls.designation.touched = true;
      controls.designation.showErrorMsg = false;
      //this.props.345(controls.designation.value);
    } else if (controlName === 'is_prospective') {
      this.props.changeFleetRegType(controls.is_prospective.value);
    } else if (controlName === 'enrollment_type') {
      if (controls.enrollment_type.value === 'indirect') {
        controls.sap_id.value = '';
      }
    }
    this.setState({ controls });
    this.handleValidation();
  }

  setBuinesssDetailFromInviteFleet = (data) => {
    let { controls } = this.state;
    controls.company_name.value = data.company_name;
    controls.owner_name.value = data.owner_name;
    controls.mobile_number.value = data.mobile_number;
    this.setState({
      controls
    })
  }


  async getState() {
    try {
      const { data } = await AddEditSubsidiariesService.getState();
      let { stateData } = this.state;
      if (data) {
        stateData = [];
        if (data.data && data.data.length > 0) {
          stateData = data.data;
        }
        this.setState((prevState) => {
          return { ...prevState, stateData, isLoading: false };
        });
      }
    } catch (error) {
      this.setState((prevState) => {
        return { ...prevState, isLoading: false };
      });
      console.log(error);
    }
  }

  cityClick(cityData) {
    this.selectedCity = cityData;
    const { controls } = this.state;
    controls.city.value = cityData;
    if (controls.city.value) {
      controls.city.showErrorMsg = false;
    }
    this.setState({ controls });
    // this.props.updateState({ visibleArea: 'vehicleRegistrationNumber', vehicleDetails: { controls, isValidForm } });
  }


  async getCity() {
    try {
      const { controls } = this.state;
      this.setState((prevState) => {
        return {
          ...prevState,
          isLoading: true
        };
      });
      const { data } = await AddEditSubsidiariesService.getCity(controls.state.value);
      let { cityData } = this.state;
      cityData = [];
      if (data) {
        if (data.data && data.data.length > 0) {
          cityData = data.data;
        }
      }
      this.setState((prevState) => {
        return {
          ...prevState,
          cityData,
          isLoading: false
        };
      });
    } catch (error) {
      this.setState((prevState) => {
        return {
          ...prevState,
          isLoading: false
        };
      });
      console.log(error);
    }
  }

  stateClick(state) {
    this.selectedState = state;
    const { controls } = this.state;
    controls.state.value = state;
    if (controls.state.value) {
      controls.state.showErrorMsg = false;
    }
    this.getCity();
    this.setState((prevState) => {
      return { ...prevState, controls };
    });
    //this.props.updateState({ visibleArea: 'vehicleSelectCity', vehicleDetails: { controls, isValidForm } });
  }


  sapIdExists = () => {
    // this.setState({
    //   isLoading: true
    // })
    // let { controls } = this.state;
    // NewFleetService.sapIdExists(controls.sap_id.value)
    //   .then(res => {
    //     if (res.data.data.exists) {
    //       controls.sap_id.isExitsSapId = true;
    //     } else {
    //       controls.sap_id.isExitsSapId = false;
    //     }
    //     this.setState({
    //       isLoading: false,
    //       controls
    //     }, () => {
    //       this.handleValidation();
    //     })
    //   })
    //   .catch(e => {
    //     this.setState({
    //       isLoading: false
    //     })
    //   });
  }

  onBlurSapId = () => {
    // this.sapIdExists();
  }


  render() {
    const { controls, is_display_prospective } = this.state;
    const { areaSalesManagerData, salesManagerData, depotData } = this.props;
    return (
      <>
        {this.state.isLoading && <CustomSpinner />}
        <Card>
          <CardBody>
            <Row className="flex-column">
              <Col>
                <b className="margin-right-16">COMPANY DETAIL</b>
              </Col>
              <span className="note-rect" style={{ border: 'none', marginLeft: '15px', marginTop: '3px', padding: '0' }}>
                All fields marked with&nbsp;(<span className="required-field">*</span>)&nbsp;are mandatory</span>
            </Row>
            <hr />
            <Row>
              {
                is_display_prospective &&
                <Col xl="12" md="12" xs="12">
                  <FormGroup>
                    <Label for="enrollment_type">Enrollment Type<span className="required-field">*</span></Label>
                    <div>
                      <label className="custom-checkboax-radio--container">
                        <input type="checkbox" name="is_prospective" value="is_prospective"
                          checked={!controls.is_prospective.value ? true : false}
                          onChange={(e) => this.handleInputChange({ target: { name: 'is_prospective', value: !controls.is_prospective.value } })}
                        />
                        <span className="checkmark-radio" />
                      </label>
                      <span style={{ marginLeft: '10px' }}>Register New Fleet With JK Baadshah</span>
                      &nbsp;&nbsp;&nbsp;
                      <label className="custom-checkboax-radio--container">
                        <input type="checkbox" name="is_prospective" value="prospective_fleet"
                          checked={controls.is_prospective.value}
                          onChange={(e) => this.handleInputChange({ target: { name: 'is_prospective', value: !controls.is_prospective.value } })} />
                        <span className="checkmark-radio" />
                      </label>
                      <span style={{ marginLeft: '10px' }}>Register As Prospective Fleet</span>
                    </div>
                    {controls.is_prospective.showErrorMsg && <div className="error">*Please select  type.</div>}
                  </FormGroup>
                </Col>
              }
              <Col xl="6" md="12" xs="12">
                <FormGroup>
                  <Label for="company_name">Company Name<span className="required-field">*</span></Label>
                  <Input
                    type="text"
                    name="company_name"
                    id="company_name"
                    value={controls.company_name.value}
                    onChange={(e) => this.handleInputChange(e)}
                    autocomplete="nofill"
                    placeholder="Enter Company Name" />
                  {controls.company_name.showErrorMsg && <div className="error">*Please enter company name.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="owner_name">Owner Name<span className="required-field">*</span></Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    name="owner_name"
                    id="owner_name"
                    onChange={(e) => this.handleInputChange(e)}
                    value={controls.owner_name.value}
                    placeholder="Enter Owner Name" />
                  {controls.owner_name.showErrorMsg && <div className="error">*Please enter owner name.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="company_type">Company Type<span className="required-field">*</span></Label>
                  <select className="form-control" name="company_type"
                    onChange={(e) => this.handleInputChange(e)} value={controls.company_type.value}>
                    <option value="" selected disabled>Select company type</option>
                    <option value="proprietor">Proprietor</option>
                    <option value="partnership">Partnership</option>
                    <option value="private limited">Private Limited</option>
                    <option value="limited">Limited</option>
                  </select>
                  {controls.company_type.showErrorMsg && <div className="error">*Please enter company type.</div>}
                </FormGroup>
              </Col>

            </Row>
            <Row>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="designation">Designation<span className="required-field">*</span></Label>
                  {/* <select className="form-control" name="designation"
                    onChange={(e) => this.handleInputChange(e)} value={controls.designation.value}>
                    <option value="" selected disabled>Select designation</option>
                    <option value="Sole proprietorship">Sole proprietorship</option>
                    <option value="Partnership">Partnership</option>
                    <option value="Pvt. Ltd.">Pvt. Ltd.</option>
                    <option value="Other">Other</option>
                  </select> */}
                  <Input
                    autocomplete="nofill"
                    type="text"
                    name="designation"
                    id="designation"
                    className="text-capitalize"
                    disabled={true}
                    value={controls.designation.value}
                    placeholder="" />
                  {controls.designation.showErrorMsg && <div className="error">*Please enter designation.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="mobile_number">Mobile Number<span className="required-field">*</span></Label>
                  <Input
                    autocomplete="nofill"
                    type="text"
                    maxLength="10"
                    value={controls.mobile_number.value}
                    onChange={(e) => this.handleInputChange(e)}
                    name="mobile_number"
                    id="mobile_number"
                    placeholder="Enter 10 Digit Number" />
                  {controls.mobile_number.showErrorMsg && <div className="error">*Please enter mobile number.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="phone_number">Phone Number<span className="required-field">*</span></Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    value={controls.phone_number.value}
                    onChange={(e) => this.handleInputChange(e)}
                    name="phone_number"
                    id="phone_number"
                    placeholder="Enter No With STD code." />
                  {controls.phone_number.showErrorMsg && <div className="error">*Please enter phone number.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="whatsapp_number">Whatsapp Number<span className="required-field">*</span></Label>
                  <Input
                    autocomplete="nofill"
                    type="text"
                    value={controls.whatsapp_number.value}
                    onChange={(e) => this.handleInputChange(e)}
                    name="whatsapp_number"
                    disabled={controls.same_as_mobile.value}
                    maxLength="10"
                    id="whatsapp_number"
                    placeholder="Enter 10 Digit  Number" />
                  {controls.whatsapp_number.showErrorMsg && <div className="error">*Please enter whatsapp number.</div>}
                  <div className="mt-1">
                    <label className="custom-checkboax1--container">
                      <input type="checkbox" name="same_as_mobile"
                        checked={controls.same_as_mobile.value}
                        onChange={(e) => this.handleInputChange(e)} />
                      <span className="checkmark1" />
                    </label>
                    <span style={{ marginLeft: '10px', fontSize: '14px' }}>Same As Mobile Number</span>
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xl="6" md="12" xs="12">
                <FormGroup>
                  <Label for="primaryPerson">Email Address<span className="required-field">*</span></Label>
                  <Input
                    autocomplete="nofill"
                    type="text"
                    value={controls.email.value}
                    onChange={(e) => this.handleInputChange(e)}
                    name="email"
                    id="email"
                    placeholder="Enter Email Address" />
                  {controls.email.showErrorMsg && <div className="error">*Please enter email.</div>}
                </FormGroup>
              </Col>
              <Col xl="6" md="12" xs="12">
                <FormGroup>
                  <Label for="website">Website</Label>
                  <Input
                    autocomplete="nofill"
                    type="text"
                    value={controls.website.value}
                    onChange={(e) => this.handleInputChange(e)}
                    name="website"
                    style={{ textTransform: 'none' }}
                    id="website"
                    placeholder="Enter Website URL" />
                  <span style={{ color: '#6D767E', marginLeft: '15px' }}>Ex. www.abc.com</span>
                </FormGroup>

              </Col>
            </Row>
            <Row>
              <Col xl="6" md="12" xs="12">
                <FormGroup>
                  <Label for="address">Address<span className="required-field">*</span></Label>
                  <TextareaAutosize
                    name="address"
                    autocomplete="nofill"
                    id="address"
                    value={controls.address.value}
                    style={{ minHeight: 120, maxHeight: 70, fontSize: '14px' }}
                    className="form-control"
                    onChange={(e) => this.handleInputChange({ target: { name: 'address', value: e.target.value } })}
                    placeholder='Enter Address'
                  />
                  {controls.address.showErrorMsg && <div className="error">*Please enter address.</div>}
                </FormGroup>
              </Col>
              <Col xl="6" md="12" xs="12">
                <Row>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="state">State<span className="required-field">*</span></Label>
                      <select className="form-control" name="state"
                        onChange={(e) => this.handleInputChange(e)} value={controls.state.value}>
                        <option value="" selected="true" disabled>Select state</option>
                        {
                          this.state.stateData && this.state.stateData.map((state) => (
                            <option key={state.state_id} value={state.state_id}>{state.name}</option>
                          ))
                        }
                      </select>
                      {controls.state.showErrorMsg && <div className="error">*Please select state.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="city">City<span className="required-field">*</span></Label>
                      <select className="form-control" name="city"
                        onChange={(e) => this.handleInputChange(e)} value={controls.city.value}>
                        <option value="" selected="true" disabled>Select city</option>
                        {
                          this.state.cityData && this.state.cityData.map((city) => (
                            <option key={city.city_id} value={city.city_id}>{city.name}</option>
                          ))
                        }
                      </select>
                      {controls.city.showErrorMsg && <div className="error">*Please select city.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="pin">Pincode<span className="required-field">*</span></Label>
                      <Input
                        autocomplete="nofill"
                        type="text"
                        value={controls.pin_code.value}
                        name="pin_code"
                        maxLength="6"
                        onChange={(e) => this.handleInputChange(e)}
                        id="pin_code"
                        placeholder="Enter Pincode" />
                      {controls.pin_code.showErrorMsg && <div className="error">*Please enter pincode.</div>}
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="fleet_manager">Fleet Manager<span className="required-field">*</span></Label>
                  <Input
                    autocomplete="nofill"
                    type="text"
                    value={this.props.fleet_manager_name}
                    name="fleet_manager"
                    disabled='true'
                    id="fleet_manager"
                    onChange={(e) => this.handleInputChange(e)}
                    placeholder="Type here" />
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="depot">Depot<span className="required-field">*</span></Label>
                  <select className="form-control" name="depot"
                    onChange={(e) => this.handleInputChange(e)} value={controls.depot.value}>
                    <option value="" selected disabled>Select depot</option>
                    {
                      depotData && depotData.map((item) => (
                        <option value={item.uuid} key={item.uuid}>{item.name}</option>
                      ))
                    }
                  </select>
                  {controls.depot.showErrorMsg && <div className="error">*Please enter depot.</div>}
                </FormGroup>
              </Col>
              <Col xl="4" md="12" xs="12">
                <FormGroup>
                  <Label for="region">Region<span className="required-field">*</span></Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    value={controls.region.value}
                    onChange={(e) => this.handleInputChange(e)}
                    name="region"
                    id="region"
                    style={{ textTransform: 'capitalize' }}
                    disabled={true}
                    placeholder="Type here" />
                  {controls.region.showErrorMsg && <div className="error">*Please enter region.</div>}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="sales_officer">Sales Officer</Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    value={controls.sales_officer.value}
                    onChange={(e) => this.handleInputChange(e)}
                    name="sales_officer"
                    id="sales_officer"
                    placeholder="Enter Sales Officer Name" />
                  {controls.sales_officer.showErrorMsg && <div className="error">*Please enter sales officer.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="sales_manager">Region Manager<span className="required-field">*</span></Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    value={salesManagerData && salesManagerData.length > 0 ? salesManagerData[0].business_name : ''}
                    onChange={(e) => this.handleInputChange(e)}
                    name="sales_manager"
                    id="sales_manager"
                    disabled="true"
                    placeholder="Type here" />
                  {controls.sales_manager.showErrorMsg && <div className="error">*Please enter sales manager.</div>}
                </FormGroup>
              </Col>
              <Col xl="4" md="12" xs="12">
                <FormGroup>
                  <Label for="area_sales_manager">Area Manager<span className="required-field">*</span></Label>
                  <select className="form-control" name="area_sales_manager"
                    onChange={(e) => this.handleInputChange(e)} value={controls.area_sales_manager.value}>
                    <option value="" selected disabled>Select area sales manager</option>
                    {
                      areaSalesManagerData && areaSalesManagerData.map((item) => (
                        <option value={item.uuid} key={item.uuid}>{item.business_name}</option>
                      ))
                    }
                  </select>
                  {controls.area_sales_manager.showErrorMsg && <div className="error">*Please enter area sales manager.</div>}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="pan_number">PAN{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    value={controls.pan_number.value}
                    onChange={(e) => this.handleInputChange(e)}
                    name="pan_number"
                    id="pan_number"
                    placeholder="Enter PAN" />
                  {controls.pan_number.showErrorMsg && <div className="error">*Please enter pan.</div>}
                </FormGroup>
              </Col>
              <Col xl="3" md="12" xs="12">
                <FormGroup>
                  <Label for="gst_number">GSTIN{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <Input
                    type="text"
                    autocomplete="nofill"
                    value={controls.gst_number.value}
                    onChange={(e) => this.handleInputChange(e)}
                    name="gst_number"
                    id="gst_number"
                    placeholder="Enter GSTIN" />
                  {controls.gst_number.showErrorMsg && <div className="error">*Please enter gstin.</div>}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xl="4" md="12" xs="12">
                <FormGroup>
                  <Label for="enrollment_type">Billing Type{!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                  <div>
                    <label className="custom-checkboax-radio--container">
                      <input type="checkbox" name="enrollment_type" value="direct"
                        checked={controls.enrollment_type.value === 'direct' ? true : false}
                        onChange={(e) => this.handleInputChange({ target: { name: 'enrollment_type', value: 'direct' } })}
                      />
                      <span className="checkmark-radio" />
                    </label>
                    <span style={{ marginLeft: '10px' }}>Direct</span>
                    &nbsp;&nbsp;&nbsp;
                    {/* <label className="custom-checkboax-radio--container">
                      <input type="checkbox" name="enrollment_type" value="indirect" checked={controls.enrollment_type.value === 'indirect' ? true : false}
                        onChange={(e) => this.handleInputChange({ target: { name: 'enrollment_type', value: 'indirect' } })} />
                      <span className="checkmark-radio" />
                    </label>
                    <span style={{ marginLeft: '10px' }}>Indirect</span>&nbsp;&nbsp;&nbsp; */}
                    <label className="custom-checkboax-radio--container">
                      <input type="checkbox" name="enrollment_type" value="mobility" checked={controls.enrollment_type.value === 'mobility' ? true : false}
                        onChange={(e) => this.handleInputChange({ target: { name: 'enrollment_type', value: 'mobility' } })} />
                      <span className="checkmark-radio" />
                    </label>
                    <span style={{ marginLeft: '10px' }}>Mobility</span>
                  </div>
                  {controls.enrollment_type.showErrorMsg && <div className="error">*Please select billing type.</div>}
                </FormGroup>
              </Col>
              {
                (controls.enrollment_type.value === 'direct' || controls.enrollment_type.value === 'mobility') &&
                <Col xl="3" md="12" xs="12">
                  <FormGroup>
                    <Label for="sap_id">SAP ID {!controls.is_prospective.value && <span className="required-field">*</span>}</Label>
                    <Input
                      type="text"
                      autocomplete="nofill"
                      value={controls.sap_id.value}
                      onChange={(e) => this.handleInputChange(e)}
                      onBlur={this.onBlurSapId}
                      name="sap_id"
                      id="sap_id"
                      placeholder="Enter SAP ID Number" />
                    {controls.sap_id.showErrorMsg && <div className="error">*Please enter SAP Id.</div>}
                    {!controls.sap_id.showErrorMsg && controls.sap_id.isExitsSapId && <div className="error">*The sap id already exists,please change it.</div>}
                  </FormGroup>
                </Col>
              }
            </Row>
          </CardBody>
        </Card>
      </>
    );
  }
}

export default NewFleetBusinessDetail;